<icon-google-logo></icon-google-logo>
<div class="text">
  <ng-content ></ng-content>
</div>
